/** Login, invitation register, recover, set password. Field labels live in ui/common.js. */
const dictionary = {
  en: {
    login: {
      loginAsOrganization: "Login as organization",
      titleMobile: "Welcome to",
      titleDesktop: "Welcome to Apex Analytics Talents Platform.",
      subtitleMobile: "Sign in to take your assessments.",
      subtitleDesktop:
        "Fill your details to enter Apex Analytics Talent Matching. Find the best career, organization or a role for you.",
      rememberMe: "Remember me",
      recoverPassword: "Recover password",
      signIn: "Log In",
      signUp: "Register",
      chromeRecommendBefore: "For the best user experience we recommend using ",
      chromeRecommendAfter: " browser.",
      downloadChrome: "download Chrome",
    },
    register: {
      titleDesktop: "Welcome to Apex Analytics Talents Platform. Register to get started.",
      subtitleDesktop:
        "Fill your details to enter Apex Analytics Talent Matching.",
      termsAgreement: "I agree with",
      termsOfService: "terms of service",
      privacyPolicy: "privacy policy",
      termsAnd: "and",
      signIn: "Log In",
      signUp: "Register",
      invitedByCompany:
        "{company} has invited you to take part in a few short assessments that will help to describe your work style, motivations and values.",
      invitedByCompanyTeam:
        "{company} has invited you to team {team} to take part in a few short assessments that will help to describe your work style, motivations and values.",
      invalidInvitationTitle: "The invitation link is invalid",
      invalidInvitationBody:
        "Please contact your company administrator for assistance.",
      invalidInvitationContact:
        "If you think this is a mistake, please contact us at admin@apexteam.ai",
      processFailed:
        "Something went wrong. Please try again. Or contact our customer support.",
    },
    recover: {
      titleMobile: "Lost your password?",
      titleDesktop: "Reset My Password",
      subtitleMobile: "Enter your details to recover",
      subtitleDesktop:
        "Reset password link will be sent to below entered email address",
      backToLogin: "Back to login",
      sendLink: "Send Reset Password Link",
      emailPlaceholder: "Your Account Email Address",
    },
    setPassword: {
      title: "Set Your New Password",
      invalidLink: "Invalid Reset Password Link",
      requestNewLink: "Request New Link",
      reset: "Reset Password",
      bothMustMatch: "Both Passwords Must Match",
    },
    stepper: {
      register: "Register",
      yourDetails: "Your details",
      assessments: "Assessments",
      results: "Results",
    },
    toasts: {
      sendingEmail: "Sending email...",
      resetLinkSent: "Password reset link sent via email",
      emailNotFound:
        "We could not find an account with that email address. Please try again.",
      genericError: "An error occurred. Please try again later.",
      resettingPassword: "Resetting password...",
      passwordUpdated:
        "Password updated successfully. You can login using new password",
      unableToReset: "Unable to reset password",
    },
  },
  de: {
    login: {
      loginAsOrganization: "Als Organisation anmelden",
      titleMobile: "Willkommen bei",
      titleDesktop: "Willkommen auf der Apex Analytics Talents Plattform.",
      subtitleMobile: "Melden Sie sich an, um Ihre Assessments durchzuführen.",
      subtitleDesktop:
        "Geben Sie Ihre Daten ein, um Apex Analytics Talent Matching zu nutzen. Finden Sie die beste Karriere, Organisation oder Rolle für sich.",
      rememberMe: "Angemeldet bleiben",
      recoverPassword: "Passwort wiederherstellen",
      signIn: "Anmelden",
      signUp: "Registrieren",
      chromeRecommendBefore: "Für die beste Nutzererfahrung empfehlen wir den ",
      chromeRecommendAfter: " Browser.",
      downloadChrome: "Chrome herunterladen",
    },
    register: {
      titleDesktop:
        "Willkommen auf der Apex Analytics Talents Plattform. Registrieren Sie sich, um zu starten.",
      subtitleDesktop:
        "Füllen Sie Ihre Daten aus, um Apex Analytics Talent Matching zu nutzen.",
      termsAgreement: "Ich stimme zu",
      termsOfService: "Nutzungsbedingungen",
      privacyPolicy: "Datenschutzerklärung",
      termsAnd: "und",
      signIn: "Anmelden",
      signUp: "Registrieren",
      invitedByCompany:
        "{company} hat Sie eingeladen, an einigen kurzen Assessments teilzunehmen, die Ihren Arbeitsstil, Ihre Motivation und Ihre Werte beschreiben.",
      invitedByCompanyTeam:
        "{company} hat Sie ins Team {team} eingeladen, um an einigen kurzen Assessments teilzunehmen, die Ihren Arbeitsstil, Ihre Motivation und Ihre Werte beschreiben.",
      invalidInvitationTitle: "Der Einladungslink ist ungültig",
      invalidInvitationBody:
        "Bitte wenden Sie sich an die Administration Ihres Unternehmens.",
      invalidInvitationContact:
        "Wenn Sie denken, dass dies ein Fehler ist, kontaktieren Sie uns unter admin@apexteam.ai",
      processFailed:
        "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut oder kontaktieren Sie unseren Support.",
    },
    recover: {
      titleMobile: "Passwort vergessen?",
      titleDesktop: "Mein Passwort zurücksetzen",
      subtitleMobile: "Geben Sie Ihre Daten zur Wiederherstellung ein",
      subtitleDesktop:
        "Der Link zum Zurücksetzen des Passworts wird an die unten angegebene E-Mail-Adresse gesendet",
      backToLogin: "Zurück zur Anmeldung",
      sendLink: "Link zum Zurücksetzen senden",
      emailPlaceholder: "E-Mail-Adresse Ihres Kontos",
    },
    setPassword: {
      title: "Neues Passwort festlegen",
      invalidLink: "Ungültiger Link zum Zurücksetzen des Passworts",
      requestNewLink: "Neuen Link anfordern",
      reset: "Passwort zurücksetzen",
      bothMustMatch: "Beide Passwörter müssen übereinstimmen",
    },
    stepper: {
      register: "Registrieren",
      yourDetails: "Ihre Daten",
      assessments: "Assessments",
      results: "Ergebnisse",
    },
    toasts: {
      sendingEmail: "E-Mail wird gesendet...",
      resetLinkSent: "Link zum Zurücksetzen des Passworts per E-Mail gesendet",
      emailNotFound:
        "Wir konnten kein Konto mit dieser E-Mail-Adresse finden. Bitte versuchen Sie es erneut.",
      genericError: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
      resettingPassword: "Passwort wird zurückgesetzt...",
      passwordUpdated:
        "Passwort erfolgreich aktualisiert. Sie können sich mit dem neuen Passwort anmelden",
      unableToReset: "Passwort konnte nicht zurückgesetzt werden",
    },
  },
  "fi": {
    "login": {
      "loginAsOrganization": "Kirjaudu sisään organisaationa",
      "titleMobile": "Tervetuloa",
      "titleDesktop": "Tervetuloa Apex Analyticsin Talent-alustalle.",
      "subtitleMobile": "Kirjaudu sisään tehdäksesi arviosi.",
      "subtitleDesktop": "Täytä tietosi, niin pääset Apex Analytics Talent Matchingiin. Löydä itsellesi sopivin ura, organisaatio tai rooli.",
      "rememberMe": "Muista minut",
      "recoverPassword": "Palauta salasana",
      "signIn": "Kirjaudu sisään",
      "signUp": "Rekisteröidy",
      "chromeRecommendBefore": "Suosittelemme käyttämään ",
      "chromeRecommendAfter": "-selainta, jotta käyttökokemus on paras mahdollinen.",
      "downloadChrome": "lataa Chrome"
    },
    "register": {
      "titleDesktop": "Tervetuloa Apex Analyticsin Talent-alustalle. Aloita rekisteröitymällä.",
      "subtitleDesktop": "Täytä tietosi, niin pääset Apex Analytics Talent Matchingiin.",
      "termsAgreement": "Hyväksyn",
      "termsOfService": "käyttöehdot",
      "privacyPolicy": "tietosuojakäytäntö",
      "termsAnd": "ja",
      "signIn": "Kirjaudu sisään",
      "signUp": "Rekisteröidy",
      "invitedByCompany": "{company} on kutsunut sinut osallistumaan muutamiin lyhyisiin arviointeihin, jotka auttavat kuvaamaan työskentelytyyliäsi, motivaatiotasi ja arvojasi.",
      "invitedByCompanyTeam": "{company} on kutsunut sinut tiimiin {team} ja osallistumaan muutamiin lyhyisiin arviointeihin, jotka auttavat kuvaamaan työskentelytyyliäsi, motivaatiotasi ja arvojasi.",
      "invalidInvitationTitle": "Kutsulinkki on virheellinen",
      "invalidInvitationBody": "Ota yhteyttä yrityksesi ylläpitäjään saadaksesi apua.",
      "invalidInvitationContact": "Jos tämä on mielestäsi virhe, ota meihin yhteyttä osoitteeseen admin@apexteam.ai",
      "processFailed": "Jotain meni pieleen. Yritä uudelleen. Tai ota yhteyttä asiakaspalveluumme."
    },
    "recover": {
      "titleMobile": "Unohditko salasanasi?",
      "titleDesktop": "Palauta salasana",
      "subtitleMobile": "Anna tietosi palautusta varten",
      "subtitleDesktop": "Salasanan palautuslinkki lähetetään alla antamaasi sähköpostiosoitteeseen",
      "backToLogin": "Takaisin kirjautumiseen",
      "sendLink": "Lähetä salasanan palautuslinkki",
      "emailPlaceholder": "Tilisi sähköpostiosoite"
    },
    "setPassword": {
      "title": "Aseta uusi salasanasi",
      "invalidLink": "Virheellinen salasanan palautuslinkki",
      "requestNewLink": "Pyydä uusi linkki",
      "reset": "Palauta salasana",
      "bothMustMatch": "Molempien salasanojen on vastattava"
    },
    "stepper": {
      "register": "Rekisteröidy",
      "yourDetails": "Tietosi",
      "assessments": "Arvioinnit",
      "results": "Tulokset"
    },
    "toasts": {
      "sendingEmail": "Lähetetään sähköpostia...",
      "resetLinkSent": "Salasanan palautuslinkki lähetetty sähköpostitse",
      "emailNotFound": "Tällä sähköpostiosoitteella ei löytynyt tiliä. Yritä uudelleen.",
      "genericError": "Tapahtui virhe. Yritä myöhemmin uudelleen.",
      "resettingPassword": "Nollataan salasanaa...",
      "passwordUpdated": "Salasana päivitetty. Voit nyt kirjautua sisään uudella salasanalla.",
      "unableToReset": "Salasanan nollaaminen epäonnistui"
    }
  }
};

export default dictionary;
